import React from "react";
import "../styles/ServiciosContenidoAds.scss";

const INCLUDES = [
  "Estrategia mensual (objetivo + enfoque de mensajes)",
  "Creación de contenido profesional (posts/reels según plan)",
  "Campañas en Facebook Ads",
  "Segmentación por zona, intereses y comportamiento",
];

const CARDS = [
  {
    title: "Contenido que vende",
    desc: "Publicaciones diseñadas para generar confianza y mover a la gente a escribirte.",
    icon: "🧩",
  },
  {
    title: "Escalamiento",
    desc: "Cuando algo funciona, lo replicamos y lo escalamos para crecer con control.",
    icon: "📈",
  },
];

const ServiciosContenidoAds = () => {
  return (
    <section className="ovit-inc" id="ovit-services">
      <div className="ovit-inc__bg" aria-hidden="true">
        <div className="ovit-inc__grid" />
        <div className="ovit-inc__glow ovit-inc__glow--1" />
        <div className="ovit-inc__glow ovit-inc__glow--2" />
      </div>

      <div className="ovit-inc__container">
        <header className="ovit-inc__header">
          <h2 className="ovit-inc__title">
            ¿Qué incluye <span>Contenido + Campañas</span>?
          </h2>
          <p className="ovit-inc__subtitle">
            Un servicio completo para atraer prospectos, generar confianza y convertir mensajes en ventas.
          </p>
        </header>

        <div className="ovit-inc__layout">
          {/* Left checklist */}
          <div className="ovit-inc__panel">
            <div className="ovit-inc__panelTop">
              <div className="ovit-inc__chip">Incluye</div>
              <div className="ovit-inc__mini">Todo pensado para resultados</div>
            </div>

            <ul className="ovit-inc__list">
              {INCLUDES.map((t) => (
                <li key={t} className="ovit-inc__item">
                  <span className="ovit-inc__check" aria-hidden="true">✓</span>
                  <span className="ovit-inc__text">{t}</span>
                </li>
              ))}
            </ul>

            <div className="ovit-inc__cta">
              <a className="ovit-inc__btn" href="#planes">
                Ver planes
              </a>
              <a className="ovit-inc__btn ovit-inc__btn--ghost" href="#proceso">
                Ver cómo trabajamos
              </a>
            </div>
          </div>

          {/* Right cards */}
          <div className="ovit-inc__cards">
            {CARDS.map((c) => (
              <article className="ovit-incCard" key={c.title}>
                <div className="ovit-incCard__icon">{c.icon}</div>
                <h3 className="ovit-incCard__title">{c.title}</h3>
                <p className="ovit-incCard__desc">{c.desc}</p>
              </article>
            ))}

            <div className="ovit-inc__miniBanner">
              <div className="ovit-inc__miniTitle">Ideal para:</div>
              <div className="ovit-inc__miniTags">
                <span>Venta de Productos</span>
                <span>Construcción</span>
                <span>Servicios Profesionales</span>
                <span>Negocios Locales</span>
                <span>Inmobiliarias</span>
                <span>Escuelas</span>
                <span>y muchos mas ...</span>
              </div>
              <a className="ovit-inc__miniLink" href="#planes">
                Elegir plan →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiciosContenidoAds;